import {useEffect, useState} from 'react';

/**
 * Уважает системную настройку «уменьшить движение».
 *
 * Нужен отдельным хуком, потому что react-awesome-reveal эту настройку не учитывает сам:
 * при true детей надо рендерить вообще без обёртки <Fade>, иначе они останутся
 * с opacity 0 до срабатывания IntersectionObserver.
 */
export const useReducedMotion = () => {
    const [reduced, setReduced] = useState(() => {
        if (typeof window === 'undefined' || !window.matchMedia) return false;
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    });

    useEffect(() => {
        if (typeof window === 'undefined' || !window.matchMedia) return undefined;
        const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
        const onChange = (e) => setReduced(e.matches);
        if (mq.addEventListener) {
            mq.addEventListener('change', onChange);
            return () => mq.removeEventListener('change', onChange);
        }
        mq.addListener(onChange);
        return () => mq.removeListener(onChange);
    }, []);

    return reduced;
};

export default useReducedMotion;
